import { render } from "./PurchaseReceiveDetail.vue?vue&type=template&id=4f695bca&scoped=true"
import script from "./PurchaseReceiveDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseReceiveDetail.vue?vue&type=script&lang=js"

import "./PurchaseReceiveDetail.vue?vue&type=style&index=0&id=4f695bca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f695bca"]])

export default __exports__